'use strict';

var React = require('react'),
    StampActionCreators = require('../actions/StampActionCreators'),
    UserActionCreators = require('../actions/UserActionCreators'),
    ZineActionCreators = require('../actions/ZineActionCreators'),
    NavigationContextTypes = require('../constants/NavigationContextTypes'),
    StampStore = require('../stores/StampStore'),
    ZineStore = require('../stores/ZineStore'),
    UserStore = require('../stores/UserStore'),
    SearchStampStore = require('../stores/SearchStampStore'),
    SearchZineStore = require('../stores/SearchZineStore'),
    SearchUserStore = require('../stores/SearchUserStore'),
    SearchStore = require('../stores/SearchStore'),
    RouterStore = require('../stores/RouterStore'),
    ScreenSizeStore = require('../stores/ScreenSizeStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    Group = require('../organisms/Group'),
    EmptyState = require('../molecules/EmptyState'),
    DocumentTitle = require('../atoms/DocumentTitle'),
    Page = require('../organisms/Page'),
    Loader = require('../atoms/Loader'),
    Container = require('../organisms/Container'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    PageQueryMixin = require('../mixins/PageQueryMixin'),
    OffsetMonitor = require('../atoms/OffsetMonitor'),
    ScrollStateMixin = require('../mixins/ScrollStateMixin'),
    getStampCountPerRow = require('../utils/getStampCountPerRow'),
    AppContext = require('../AppContext'),
    { replaceWith } = require('../router'),
    { debounce } = require('underscore');

require('../atoms/SearchInput.less');

var COLUMNS = 4,
    STAMP_ROW_COUNT = 2,
    ZINE_ROW_COUNT = 1,
    USER_ROW_COUNT = 1;

var SearchPage = React.createClass({
  mixins: [
    createStoreMixin(
      StampStore,
      ZineStore,
      UserStore,
      SearchStampStore,
      SearchZineStore,
      SearchUserStore,
      SearchStore,
      ScreenSizeStore
    ),
    PageQueryMixin,
    PureRenderMixin,
    ScrollStateMixin
  ],

  getStateFromStores() {
    var currentTerms = SearchStore.getTermsFromRoute(),
        readyTerms = SearchStore.getLastTermsWithData(),
        screenSize = ScreenSizeStore.getScreenSize(),
        itemsPerRow = getStampCountPerRow(screenSize, COLUMNS);

    return {
      currentTerms: currentTerms,
      readyTerms: readyTerms,

      isExpectingCurrentTermsPage:
        SearchStampStore.isExpectingPage(currentTerms) ||
        SearchUserStore.isExpectingPage(currentTerms) ||
        SearchZineStore.isExpectingPage(currentTerms),

      itemsPerRow: itemsPerRow,

      stamps: SearchStampStore.getStamps(readyTerms),
      isExpectingStampPage: SearchStampStore.isExpectingPage(readyTerms),
      isLastStampPage: SearchStampStore.isLastPage(readyTerms),

      users: SearchUserStore.getUsers(readyTerms),
      isExpectingUserPage: SearchUserStore.isExpectingPage(readyTerms),
      isLastUserPage: SearchUserStore.isLastPage(readyTerms),

      zines: SearchZineStore.getZines(readyTerms),
      isExpectingZinePage: SearchZineStore.isExpectingPage(readyTerms),
      isLastZinePage: SearchZineStore.isLastPage(readyTerms)
    };
  },

  getScrollState() {
    return {
      hasScrolledPastZines: this.hasScrolledPastOffset(this._zinesOffsetTop),
      hasScrolledPastUsers: this.hasScrolledPastOffset(this._usersOffsetTop),
      hasScrolledPastStamps: this.hasScrolledPastOffset(this._stampsOffsetTop)
    };
  },

  componentWillMount() {
    this._zinesOffsetTop = 0;
    this._usersOffsetTop = 0;
    this._stampsOffsetTop = 0;
  },

  componentDidMount() {
    this.debounceRequestSearchPage = debounce(this.requestSearchPage, 700);
    this.requestSearchPage();
  },

  getNavigationContext() {
    const {
      hasScrolledPastUsers,
      hasScrolledPastZines,
      hasScrolledPastStamps
    } = this.state;

    return [NavigationContextTypes.SEARCH, {
      hasScrolledPastUsers,
      hasScrolledPastZines,
      hasScrolledPastStamps
    }];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    return {
      navigationContextType,
      navigationContextOptions
    };
  },

  render() {
    var {
      stamps, isExpectingStampPage, isLastStampPage,
      users, isExpectingUserPage, isLastUserPage,
      zines, isExpectingZinePage, isLastZinePage,
      itemsPerRow, currentTerms, readyTerms
    } = this.state;

    var perStampsFirstPage = itemsPerRow * STAMP_ROW_COUNT,
        perUsersFirstPage = itemsPerRow * USER_ROW_COUNT,
        perZinesFirstPage = itemsPerRow * ZINE_ROW_COUNT,
        isEmpty;

    isEmpty = (
      currentTerms === readyTerms &&
      currentTerms.length > 0 &&
      stamps.length === 0 && users.length === 0 && zines.length === 0 &&
      isLastStampPage && isLastUserPage && isLastZinePage &&
      !isExpectingStampPage && !isExpectingUserPage && !isExpectingZinePage
    );

    return (
      <AppContext {...this.getAppContext()}>
        <DocumentTitle title='Search'>
          <Page>
            {this.renderInput()}

            {zines.length > 0 &&
              <OffsetMonitor onOffsetTopChange={this.handleZinesOffsetTopChange}>
                <Container context='Page'>
                  <Group type='zines'
                         title='Matching Collections'
                         mode='grid'
                         columns={COLUMNS}
                         perFirstPage={perZinesFirstPage}
                         context='page'
                         items={zines}
                         itemProps={{ size: 'small' }}
                         isExpectingPage={isExpectingZinePage}
                         isLastPage={isLastZinePage}
                         defaultPage={this.parsePage(2)}
                         onPageChange={page => this.replacePage(2, page)}
                         loadNextPage={this.requestNextZinePage} />
                </Container>
              </OffsetMonitor>
            }

            {users.length > 0 &&
              <OffsetMonitor onOffsetTopChange={this.handleUsersOffsetTopChange}>
                <Container context='Page'>
                  <Group type='users'
                         title='Matching Users'
                         mode='grid'
                         columns={COLUMNS}
                         perFirstPage={perUsersFirstPage}
                         context='page'
                         items={users}
                         itemProps={{
                           vertical: true,
                           size: 'small',
                           imageSize: 'large',
                           showLocation: true,
                           showAbout: true,
                           showFollow: true
                         }}
                         isExpectingPage={isExpectingUserPage}
                         isLastPage={isLastUserPage}
                         defaultPage={this.parsePage(1)}
                         onPageChange={page => this.replacePage(1, page)}
                         loadNextPage={this.requestNextUserPage} />
                </Container>
              </OffsetMonitor>
            }

            {stamps.length > 0 &&
              <OffsetMonitor onOffsetTopChange={this.handleStampsOffsetTopChange}>
                <Container context='Page'>
                  <Group type='stamps'
                         mode='grid'
                         title='Matching Stamps'
                         columns={COLUMNS}
                         perFirstPage={perStampsFirstPage}
                         context='page'
                         items={stamps}
                         itemProps={{ size: 'small' }}
                         isExpectingPage={isExpectingStampPage}
                         isLastPage={isLastStampPage}
                         defaultPage={this.parsePage(0)}
                         onPageChange={page => this.replacePage(0, page)}
                         loadNextPage={this.requestNextStampPage} />
                </Container>
              </OffsetMonitor>
            }

            {isEmpty &&
              this.renderEmptyState()
            }
          </Page>
        </DocumentTitle>
      </AppContext>
    );
  },

  renderInput() {
    var { isExpectingCurrentTermsPage } = this.state;

    return (
      <Container context='Page'>
        <div className='utils--displayFlex'
             style={{ width: '100%' }}>
          <input type='text'
                 className='SearchInput'
                 placeholder='Type to search'
                 autoFocus
                 defaultValue={SearchStore.getTermsFromRoute()}
                 onChange={this.handleQueryChange} />

          {isExpectingCurrentTermsPage &&
            <Loader withPadding={false}
                    context='Search' />
          }
        </div>
      </Container>
    );
  },

  renderEmptyState() {
    return (
      <Container context='Page'>
        <EmptyState label='Nothing found.'
                    absoluteCenter />
      </Container>
    );
  },

  handleZinesOffsetTopChange(zinesOffsetTop) {
    this._zinesOffsetTop = zinesOffsetTop;
    this.updateScrollState();
  },

  handleUsersOffsetTopChange(usersOffsetTop) {
    this._usersOffsetTop = usersOffsetTop;
    this.updateScrollState();
  },

  handleStampsOffsetTopChange(stampsOffsetTop) {
    this._stampsOffsetTop = stampsOffsetTop;
    this.updateScrollState();
  },

  handleQueryChange(e) {
    var { params, query } = RouterStore.getRouterState(),
        terms = e.target.value;

    query = Object.create(query);

    if (terms.length > 0) {
      query.q = terms;
    } else {
      delete query.q;
    }

    replaceWith('search', params, query);
    this.debounceRequestSearchPage();
  },

  requestSearchPage() {
    var terms = SearchStore.getTermsFromRoute();
    if (!terms.length) {
      return;
    }

    StampActionCreators.requestSearchPage(terms, true);
    UserActionCreators.requestSearchPage(terms, true);
    ZineActionCreators.requestSearchPage(terms, true);
  },

  requestNextStampPage() {
    var terms = SearchStore.getTermsFromRoute();
    StampActionCreators.requestSearchPage(terms);
  },

  requestNextUserPage() {
    var terms = SearchStore.getTermsFromRoute();
    UserActionCreators.requestSearchPage(terms);
  },

  requestNextZinePage() {
    var terms = SearchStore.getTermsFromRoute();
    ZineActionCreators.requestSearchPage(terms);
  }
});

module.exports = SearchPage;



/** WEBPACK FOOTER **
 ** ./pages/SearchPage.jsx
 **/